<div class="view" id="viewport" style="height: 100%; width: 100%; ">
          <rhinoartisan-web-experience #viewerElement *ngIf="showViewer"
                style="height: 100%; width: 100%; "></rhinoartisan-web-experience>
    <div class="logo">
        <img src="../../../../../../assets/img/logo-with-icon.png" alt="">
    </div>
</div>